import { render } from "./CavityInspection.vue?vue&type=template&id=23c84c52&scoped=true"
import script from "./CavityInspection.vue?vue&type=script&lang=js"
export * from "./CavityInspection.vue?vue&type=script&lang=js"

import "./CavityInspection.vue?vue&type=style&index=0&id=23c84c52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c84c52"]])

export default __exports__